import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Stepper, Avatar, Link } from "@mui/material";
import { useAppSelector } from "../../../infra/hooks";
import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import { fonts } from "../../themes/themes";
import moment from "moment";

interface contentTileType {
  review_heading: string;
  review_value: string;

  name?: any;
  days?: any;
}
const TeamReviewTile: React.FC<contentTileType> = ({
  review_heading,
  review_value,

  name,
  days,
}) => {
  return (
    <Box
      style={{
        backgroundColor: "#FAFAFA",
        borderRadius: "1em",
        padding: "0.5em",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box>
        <Avatar />
      </Box>
      <Box
        style={{
          marginLeft: "1em",
          width: "100%",
        }}
      >
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography
              style={{
                fontSize: "0.8em",
                color: "#1C1D21",
                fontFamily: fonts.fontFamily,
              }}
            >
              {review_heading}
            </Typography>
            <Typography
              style={{
                fontSize: "0.7em",
                color: "#081735",
                fontWeight: "bold",
                fontFamily: fonts.fontFamily,
              }}
            >
              {name}
            </Typography>
            <Typography
              style={{
                fontSize: "0.7em",
                color: "#9E9E9E",
                fontFamily: fonts.fontFamily,
              }}
            >
              due in {days} days
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "right",
            }}
          >
            <Link
              style={{
                fontSize: "0.725em",
                color: "#4CAF50",
                fontFamily: fonts.fontFamily,
                cursor: "pointer",
              }}
            >
              Sign <i className="las la-angle-right" />
            </Link>
          </Box>
        </Box>

        <Box style={{ marginTop: "0.5em" }}>
          <LinearProgress
            variant="determinate"
            value={49}
            sx={{
              "&.MuiLinearProgress-root": {
                backgroundColor: "#E6E8F0",
              },
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#4CAF50",
                boxShadow: "#00000029",
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TeamReviewTile;
